import { z } from "zod";

// TODO: possible move this schemas to @core package
export const FORM_TYPES = [
  "drill",
  "hseq_visit",
  "investigation",
  "observation",
  "management",
  "mailbox",
] as const;

export const formTypeSchema = z.enum(FORM_TYPES);

export type FormType = z.infer<typeof formTypeSchema>;

export const dateFilterSchema = z.enum([
  "this_week",
  "this_month",
  "this_year",
  "all_time",
]);
export type DateFilter = z.infer<typeof dateFilterSchema>;

export const photoSchema = z.object({
  r2Key: z.string(),
  url: z.string().optional(),
  filename: z.string(),
  contentType: z.string(),
});

export type Photo = z.infer<typeof photoSchema>;

export const videoSchema = z.object({
  r2Key: z.string(),
  url: z.string().optional(),
  filename: z.string(),
  contentType: z.string(),
});

export type Video = z.infer<typeof videoSchema>;

export const participantSchema = z.object({
  name: z.string().min(1),
  role: z.string().min(1),
  signature: z.string().nullable(),
});

export type Participant = z.infer<typeof participantSchema>;

// Specific participant structure for Investigation forms
export const investigationParticipantSchema = z.object({
  name: z.string().min(1),
  role: z.string().min(1),
  employeeSeniority: z.string().min(1),
  jobPosition: z.string().min(1),
  signature: z.string().nullable(),
});

export type InvestigationParticipant = z.infer<
  typeof investigationParticipantSchema
>;

export const timingSchema = z.object({
  date: z.string(),
  event: z.string(),
  observation: z.string().nullable(),
});

export type Timing = z.infer<typeof timingSchema>;

export const witnessSchema = z.object({
  id: z.string(),
  value: z.string().min(1),
});

export type Witness = z.infer<typeof witnessSchema>;

/////////////////////
// FILES VALIDATION
/////////////////////
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];
const ACCEPTED_VIDEO_TYPES = ["video/mp4", "video/webm", "video/mov"];

const genericFileWithValidationSchema = z
  .custom<File>()
  .refine((file) => file instanceof File, "File is required")
  .refine((file) => file.size <= MAX_FILE_SIZE, "Max file size is 5MB");

export const photoWithValidationSchema = genericFileWithValidationSchema.refine(
  (file) => ACCEPTED_IMAGE_TYPES.includes(file.type),
  "Only .jpg, .jpeg, .png and .webp files are accepted",
);

export type PhotoWithValidation = z.infer<typeof photoWithValidationSchema>;

export const videoWithValidationSchema = genericFileWithValidationSchema.refine(
  (file) => ACCEPTED_VIDEO_TYPES.includes(file.type),
  "Only .mp4, .webm and .mov files are accepted",
);

export type VideoWithValidation = z.infer<typeof videoWithValidationSchema>;
